import * as React from 'react';
import {styled} from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import {FormControlLabel} from "@material-ui/core";

const MySwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({theme}) => ({
    width: 40,
    height: 20,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 1,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#24c6af' : '#24c6af',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#24c6af',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 14,
        height: 14,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#dfdfdf' : '#dfdfdf',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}))

export default function CustomSwitch(props) {

    return (<table
        className="horizontalFullScreen marginRightSmall"
        onClick={props.onChange ? props.onChange : undefined}>
        <tbody className="fullWidth">
        <tr className="fullWidth">
            {props.text &&
            <td className="fullWidth mediumTextBold">
                {props.text}
            </td>
            }
            <td>
                <FormControlLabel
                    label=""
                    checked={props.checked}
                    control={<MySwitch sx={{m: 1}}/>}/>
            </td>
        </tr>
        </tbody>
    </table>)
}